import { TotalCostInfo } from 'components/Pages/Admin/Itinerary/Landing/Costs';
import { TTotalCostInfoProps } from 'components/Pages/Admin/Itinerary/Landing/Costs/types';
import Text from 'components/shared/Typography/Text';

import { useBlockContext } from '../../../../../LandingV2/Page/RightSide/Block/context';

function TotalCosts() {
  const { block } = useBlockContext();
  return (
    <Text>
      <TotalCostInfo {...(block.data as TTotalCostInfoProps)} />
    </Text>
  );
}

export default TotalCosts;
